<template>
  <div>
    <input type="file" accept="image/*" @change="onFileChange" />

    <div v-if="imageLoaded">
      <canvas ref="canvas" width="500" height="300"
              @mousedown="startDrawing"
              @mousemove="drawOrDrag"
              @mouseup="stopDrawing"
              @mouseleave="stopDrawing"
              style="border: 1px solid #aaa; touch-action: none;"></canvas>

      <button class="btn btn-success mt-2" @click="saveMaskedImage">
        Save Masked Aadhaar
      </button>
    </div>

    <div v-if="maskedImageUrl" class="mt-3">
      <h6>Preview:</h6>
      <img :src="maskedImageUrl" width="300" />
    </div>
    <div v-else>
        <img :src="this.$hostname+'/writable/uploads/aadhar_card/user.png'"  @click="triggerFileInput" alt="Uploaded Image" style="height: 80px; width: 80px;" />
    </div>
  </div>
</template>

<script>
export default {
  name: "AadhaarMasker",
  data() {
    return {
      canvas: null,
      ctx: null,
      image: null,
      imageLoaded: false,
      startX: 0,
      startY: 0,
      isDrawing: false,
      isDragging: false,
      rect: { x: 0, y: 0, width: 0, height: 0 },
      offsetX: 0,
      offsetY: 0,
      maskedImageUrl: null
    };
  },
  methods: {
    onFileChange(e) {
      const file = e.target.files[0];
      if (!file) return;

      this.image = new Image();
      this.image.onload = () => {
        this.canvas = this.$refs.canvas;
        this.ctx = this.canvas.getContext("2d");
        this.ctx.clearRect(0, 0, this.canvas.width, this.canvas.height);
        this.ctx.drawImage(this.image, 0, 0, this.canvas.width, this.canvas.height);
        this.imageLoaded = true;

        this.rect = { x: 100, y: 220, width: 250, height: 30 };
        this.drawAll();
      };
      this.image.src = URL.createObjectURL(file);
    },
    drawAll() {
      this.ctx.clearRect(0, 0, this.canvas.width, this.canvas.height);
      this.ctx.drawImage(this.image, 0, 0, this.canvas.width, this.canvas.height);
      this.ctx.fillStyle = "black";
      this.ctx.fillRect(this.rect.x, this.rect.y, this.rect.width, this.rect.height);
    },
    startDrawing(e) {
      const rectCanvas = this.canvas.getBoundingClientRect();
      const x = e.clientX - rectCanvas.left;
      const y = e.clientY - rectCanvas.top;

      if (
        x > this.rect.x && x < this.rect.x + this.rect.width &&
        y > this.rect.y && y < this.rect.y + this.rect.height
      ) {
        this.isDragging = true;
        this.offsetX = x - this.rect.x;
        this.offsetY = y - this.rect.y;
      } else {
        this.isDrawing = true;
        this.startX = x;
        this.startY = y;
        this.rect = { x, y, width: 0, height: 0 };
      }
    },
    drawOrDrag(e) {
      if (!this.ctx) return;
      const rectCanvas = this.canvas.getBoundingClientRect();
      const x = e.clientX - rectCanvas.left;
      const y = e.clientY - rectCanvas.top;

      if (this.isDragging) {
        this.rect.x = x - this.offsetX;
        this.rect.y = y - this.offsetY;
        this.drawAll();
      }

      if (this.isDrawing) {
        this.rect.width = x - this.startX;
        this.rect.height = y - this.startY;
        this.rect.x = this.startX;
        this.rect.y = this.startY;
        this.drawAll();
      }
    },
    stopDrawing() {
      this.isDrawing = false;
      this.isDragging = false;
    },
    saveMaskedImage() {
      this.canvas.toBlob(blob => {
        const url = URL.createObjectURL(blob);
        this.maskedImageUrl = url;

        // 🔁 Emit the masked blob to parent for upload
        this.$emit("image-masked", blob);
      }, "image/png");
    }
  }
};
</script>
